import React from 'react';
import { Toaster } from "@/components/ui/sonner";

import { VideoBackground } from '../components/VideoBackground';
import { ContactForm } from '../components/ContactForm';
import { Navbar } from '../components/sections/Navbar';
import { HeroSection } from '../components/sections/HeroSection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { AboutSection } from '../components/sections/AboutSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { SiteFooter } from '../components/sections/SiteFooter';

const LandingPage = () => (
  <div className="min-h-screen bg-transparent relative">
    <VideoBackground />

    <div className="relative text-[var(--text-primary)] font-sans selection:bg-[var(--brand-primary)] selection:text-black content">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />

      <section id="contact" className="py-20 md:py-32">
        <div className="container mx-auto px-6">
          <ContactForm />
        </div>
      </section>

      <FinalCTASection />
      <SiteFooter />
      <Toaster />
    </div>
  </div>
);

export default LandingPage;
